import { BaseWebComponentRepository } from '../../../framework/BaseWebComponentRepository';
import { NotesListDataProviderFactory } from '../factory/NotesListDataProviderFactory';
import { CreateNoteRequest, DeleteNoteRequest, UpdateNoteRequest } from '../types';
import { NotesListBaseDataProvider } from '../dataProvider/NotesListBaseDataProvider';
import { Note } from '../../types';

export class NotesListRepository extends BaseWebComponentRepository {
  public dataProviderFactory: NotesListDataProviderFactory;
  public dataProvider: NotesListBaseDataProvider;

  constructor() {
    super();

    this.initialSetup({
      dataProviderFactory: new NotesListDataProviderFactory(),
    });
  }

  public async getNotes(): Promise<Note[]> {
    return this.dataProvider.getNotes();
  }

  public async createNote(request: CreateNoteRequest): Promise<void> {
    await this.dataProvider.createNote(request);
  }

  public async updateNote(request: UpdateNoteRequest): Promise<void> {
    await this.dataProvider.updateNote(request);
  }

  public async deleteNote(request: DeleteNoteRequest): Promise<void> {
    await this.dataProvider.deleteNote(request);
  }
}
